<app-header [sportId]="sportId" [sportName]="sportName" [date]="date" eventType="races"
            [eventListLink]="['/page', 'stage', 'stage-list']"
></app-header>

<main role="main">
    <router-outlet></router-outlet>
</main>

<app-footer [sportName]="sportName"></app-footer>
